import React from 'react'
import ReactDOM from 'react-dom'
import { RouterProvider } from 'react-router-dom'

import * as amplitude from '@amplitude/analytics-browser'
import * as FullStory from '@fullstory/browser'

import { router } from './routes'

import './styles/main.scss'

if (process.env.REACT_APP_ANALYTICS_KEY) {
  amplitude.init(process.env.REACT_APP_ANALYTICS_KEY)
}
if (process.env.REACT_APP_FULLSTORY_ID) {
  FullStory.init({ orgId: process.env.REACT_APP_FULLSTORY_ID })
}

ReactDOM.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
  document.getElementById('root')
)
